module.exports = __webpack_public_path__ + "img/icon-yachts.61958e51.svg";